import {
  SortDirectionEnum,
  TerminHistoriaZmien as TerminHistoriaZmienGenerated,
  TerminHistoriaZmienApi,
  TerminHistoriaZmienPage as TerminHistoriaZmienPageGenerated,
} from 'tezaury-frontend-ts-axios';
import { AxiosRequestHeaders } from 'axios';
import { tezauryPrefixPath } from '../configuration/apiConfigurationConstants';
import apiConfiguration from '../configuration/apiConfiguration';
import { ClientResponse } from '../../model/ClientResponse';
import Uuid from '../../model/Uuid';
import TerminHistoriaZmienPage from '../../model/TerminHistoriaZmienPage';
import TerminHistoriaZmien from '../../model/TerminHistoriaZmien';
import stringToDate from '../../functions/stringToDate';

const client = new TerminHistoriaZmienApi(apiConfiguration(tezauryPrefixPath));

const mapHistoriaZmien = (data: TerminHistoriaZmienGenerated): TerminHistoriaZmien => ({
  uuid: data.uuid,
  datum: data.datum ? stringToDate(data.datum) : undefined,
  autor: data.autor,
  typ: data.typ,
  oblast: data.oblast,
});

const map = (data: TerminHistoriaZmienPageGenerated): TerminHistoriaZmienPage => ({
  terminNazov: data.terminNazov,
  tezaurusNazov: data.tezaurusNazov,
  historiaZmienList: data.historiaZmienList.map(material => mapHistoriaZmien(material)),
  number: data.number,
  size: data.size,
  totalElements: data.totalElements,
});

// eslint-disable-next-line import/prefer-default-export
export const fetchTerminHistoriaZmienPage = async (
  terminUuid?: Uuid,
  page?: number,
  size?: number,
  sortBy?: string,
  sortDirection?: SortDirectionEnum,
  options: { headers?: AxiosRequestHeaders } = {},
):
  Promise<ClientResponse<TerminHistoriaZmienPage>> => {
  const {
    data,
    status,
  } = await client.getHistoriaZmien(
    terminUuid || '',
    page,
    size,
    sortBy,
    sortDirection,
    options,
  );

  return {
    data: map(data),
    responseCode: status,
  };
};
